import _isEmpty from 'lodash/isEmpty';

import CustomFonts from './CustomFonts';
import StaticFontOptions from './StaticFontOptions';

const getBrandFontsArray = (primaryFont, secondaryFont, allCustomFonts) => {
    let primaryFontValue = primaryFont;
    let secondaryFontValue = secondaryFont;
    if (allCustomFonts.length > 0) {
        allCustomFonts.forEach((font) => {
            primaryFontValue = primaryFont === font.label ? font.value : primaryFontValue;
            secondaryFontValue = secondaryFont === font.label ? font.value : secondaryFontValue;
        });
    }

    // adding fontID if the font is a custom font, so we can tell the difference
    const customPrimaryFont = allCustomFonts.find((font) => font.value === primaryFontValue && font.fontID);
    const customSecondaryFont = allCustomFonts.find((font) => font.value === secondaryFontValue && font.fontID);

    if (primaryFont === secondaryFont) {
        if (primaryFont === 'Arial Black')
            return [{ value: "'Arial Black'", label: 'Arial Black' }];
        else
            return [{ value: primaryFontValue, label: primaryFont }];
    }
    return [
        { value: primaryFont === 'Arial Black' ? "'Arial Black'" : primaryFontValue, label: primaryFont, fontID: customPrimaryFont?.fontID },
        { value: secondaryFont === 'Arial Black' ? "'Arial Black'" : secondaryFontValue, label: secondaryFont, fontID: customSecondaryFont?.fontID },
    ];
};

const filterBrandFonts = (fonts, brandFonts) =>
    fonts.filter((item) => !brandFonts.some((brandFont) => brandFont.value === item.value));

/*
 * We are using the Singleton pattern in order to avoid unnecessary operations since the fonts
 * are going to be the same for the whole user session and for all FontOptions rendered.
 */
export default class FontOptions {
    static instance = null;

    constructor({
        hasFullStylingAccess,
        hasIntegrationCustomFontsAccess,
        customizationPrimaryFont,
        customizationSecondaryFont,
        customFonts,
    }) {
        if (!FontOptions.instance) {
            FontOptions.instance = this;

            this.hasFullStylingAccess = hasFullStylingAccess;
            this.customizationPrimaryFont = customizationPrimaryFont;
            this.customizationSecondaryFont = customizationSecondaryFont;
            this.customFonts = customFonts;
            this.fontOptions = StaticFontOptions;

            const allCustomFonts = new CustomFonts(customFonts);
            const brandFonts = getBrandFontsArray(customizationPrimaryFont, customizationSecondaryFont, allCustomFonts);
            const filteredCustomFonts = filterBrandFonts(allCustomFonts, brandFonts);
            const filteredDefaultFonts = filterBrandFonts(this.fontOptions.fontFamily[2].options, brandFonts);

            this.fontOptions.fontFamily[0].options = brandFonts;
            this.fontOptions.fontFamily[2].options = hasFullStylingAccess ? filteredDefaultFonts : [];

            if (hasIntegrationCustomFontsAccess) {
                this.fontOptions.fontFamily[1].options = hasFullStylingAccess ? filteredCustomFonts : [];
            }
        }

        return FontOptions.instance;
    }

    get values() {
        return this.fontOptions;
    }

    setCustomFonts(customFonts) {
        // set custom fonts only once to avoid operations
        if (FontOptions.instance && _isEmpty(this.customFonts)) {
            this.customFonts = customFonts;

            const allCustomFonts = new CustomFonts(customFonts);
            const brandFonts = getBrandFontsArray(
                this.customizationPrimaryFont,
                this.customizationSecondaryFont,
                allCustomFonts
            );
            const filteredCustomFonts = filterBrandFonts(allCustomFonts, brandFonts);
            const filteredDefaultFonts = filterBrandFonts(this.fontOptions.fontFamily[2].options, brandFonts);

            this.fontOptions.fontFamily[0].options = brandFonts;
            this.fontOptions.fontFamily[1].options = this.hasFullStylingAccess ? filteredCustomFonts : [];
            this.fontOptions.fontFamily[2].options = this.hasFullStylingAccess ? filteredDefaultFonts : [];
        }
    }
}
